import React, { useEffect, useState } from 'react';
import Map, { Marker, Popup } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import HappyHourApi from '../api/backendApi.js';
import { Link } from 'react-router-dom';

const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

const geocodeAddress = async (address) => {
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json?access_token=${MAPBOX_TOKEN}`;
  const res = await fetch(url);
  const data = await res.json();
  if (data.features && data.features.length > 0) {
    const [lng, lat] = data.features[0].center;
    return { lat, lng };
  }
  return null;
};

const MapComponent = () => {
  const [spaceLocations, setSpaceLocations] = useState([]);
  const [clickedSpace, setClickedSpace] = useState(null);
  const [viewState, setViewState] = useState({
    longitude: -98.5795,
    latitude: 39.8283,
    zoom: 4,
  });

  useEffect(() => {
    const fetchSpaceLocations = async () => {
      try {
        const response = await HappyHourApi.request('spaces');
        const spaces = response.spaces;

        if (!Array.isArray(spaces)) {
          console.error('Invalid response format. Expected an array of spaces.');
          return;
        }

        const locations = await Promise.all(
          spaces.map(async (space) => {
            const coords = await geocodeAddress(space.address);
            if (!coords) return null;
            return { id: space.space_id, title: space.title, ...coords };
          })
        );

        const valid = locations.filter(Boolean);
        setSpaceLocations(valid);

        if (valid.length > 0) {
          setViewState((v) => ({ ...v, longitude: valid[0].lng, latitude: valid[0].lat, zoom: 10 }));
        }
      } catch (error) {
        console.error('Error while fetching space locations:', error);
      }
    };

    fetchSpaceLocations();
  }, []);

  return (
    <Map
      {...viewState}
      onMove={(e) => setViewState(e.viewState)}
      style={{ width: '100%', height: '700px' }}
      mapStyle="mapbox://styles/mapbox/light-v11"
      mapboxAccessToken={MAPBOX_TOKEN}
    >
      {spaceLocations.map((space) => (
        <Marker
          key={space.id}
          longitude={space.lng}
          latitude={space.lat}
          color="#e07b6e"
          onClick={(e) => { e.originalEvent.stopPropagation(); setClickedSpace(space); }}
        />
      ))}

      {clickedSpace && (
        <Popup
          longitude={clickedSpace.lng}
          latitude={clickedSpace.lat}
          anchor="bottom"
          onClose={() => setClickedSpace(null)}
          closeOnClick={false}
        >
          <Link to={`/spaces/${clickedSpace.title}`} style={{ fontWeight: 600, color: '#e07b6e' }}>
            {clickedSpace.title}
          </Link>
        </Popup>
      )}
    </Map>
  );
};

export default MapComponent;
